@import '~style-sheet-helpers/core.less';
@import (reference) '~ss-ui-client/src/constants/spacing.module.less';
@import '~ss-ui-client/src/app-brand/entities/entity-layer.module.less';

.autocomplete-scanner-icon {
  position: static;
  height: 16px;
  aspect-ratio: 1;
}
.product-search-container {
  margin-bottom: @space-16;

  .search-input-container {
    display: flex;
    align-items: center;
    //width should match half of the shipping details form inputs minus half of shipping details form gap between them
    max-width: calc(50% - 16px);
    font-size: 14px;
    padding-right: @space-0;
    position: relative;

    .search-input {
      flex: 1;
      height: 32px;
    }

    .search-button {
      border-radius: 0 4px 4px 0;
      min-width: auto;
      height: 32px;
      width: 32px;
      border: none;
      position: absolute;
      top: 0;
      right: 0;
      //z-index set to 2 because already existing input component has z-index set to 1
      z-index: 2;
      background-color: transparent;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.search-text-base {
  font-size: 12px;
  margin-top: @space-8;
  margin-bottom: @space-16;
}

.search-helper-text {
  .search-text-base();
  color: var(--grey-600);
}

.search-error-text-placeholder {
  height: 24px;
}
.actions-input-container {
  display: flex;
  align-items: right;
  gap: @space-8;
  margin-top: @space-8;
  margin-bottom: @space-16;
}
